export default __webpack_public_path__ + "static/media/Documentos-afiliacion-banco-del-pacifico.1abc3dc9.pdf";